/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import '../../css/style.css';
import {
	useEffect,
	useState
} from "react";
import Loading from "@components/Loading";
import {sendImages} from "@util/ServerUtils";
import SentResult from "@components/SentResult";
import {t} from "@util/i18n";


const backgroundImage = require("../../res/images/bg.jpg");
const successIcon = require("../../res/images/sentIcon.png");
const failIcon = require("../../res/images/sentFailIcon.png");

interface SentScreenProps {
	openFileFunc: () => void;
	selectedImages: File[];
}

const SentScreen = ({openFileFunc, selectedImages}: SentScreenProps) => {
	const [loading, setLoading] = useState(true);
	const [success, setSuccess] = useState<boolean | null>(null);


	const isMobile = window.innerWidth <= 768
	const backgroundImageStyle = {
		backgroundImage: `url(${backgroundImage})`,
		backgroundSize: 'cover',
		backgroundPosition: 'center bottom',
		backgroundAttachment: 'fixed'
	};

	useEffect(() => {
		const fetchData = async () => {
			try {
				const sendResult = await sendImages(selectedImages, isMobile) as boolean | null;
				setSuccess(sendResult);
			} catch (error) {
				console.error('Error sending images:', error);
				setSuccess(false);
			} finally {
				setLoading(false);
			}
		};

		fetchData().catch(console.error);
	}, []);

	const handleMorePhotos = () => {
		openFileFunc();
	};

	return (
		isMobile ? (
			<div className="bgDiv sentScreenContainer" style={backgroundImageStyle}>
				{loading && <Loading text={t("uploading")} />}
				{success === true && (
					<SentResult
						onClick={handleMorePhotos}
						textLine1={t("sentSuccess")}
						textBtn={t("addMorePhotos")}
						iconSrc={successIcon}
						isMobile={isMobile}
					/>
				)}
				{success === false && (
					<SentResult
						onClick={handleMorePhotos}
						textLine1={t("sentFail")}
						textBtn={t("tryAgain")}
						iconSrc={failIcon}
						isMobile={isMobile}
					/>
				)}
			</div>
		) : (
			<div className="bgSendScreenDiv">
				<div className={"sendWebBgContainer"}>
					{loading && <Loading text={t("uploading")} />}
					{success === true && (
						<SentResult
							onClick={handleMorePhotos}
							textLine1={t("sentSuccess")}
							textBtn={t("addPhotos")}
							iconSrc={successIcon}
							isMobile={isMobile}
						/>
					)}
					{success === false && (
						<SentResult
							onClick={handleMorePhotos}
							textLine1={t("sentFail")}
							textBtn={t("tryAgain")}
							iconSrc={failIcon}
							isMobile={isMobile}
						/>
					)}
				</div>


			</div>
		)
	);


};

export default SentScreen;
